module.exports = __webpack_public_path__ + "img/photo.d9c6ef1f.jpg";